import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { BUTTON__CONTENT_CLASS } from '../../Button/constants';

const SMALL_SIZE = 36;
const SMALL_HOVER_SIZE = SMALL_SIZE - 4;
const LARGE_SIZE = 44;
const LARGE_HOVER_SIZE = LARGE_SIZE - 4;

export const small = css`
  width: ${pxToRem(SMALL_SIZE)};
  height: ${pxToRem(SMALL_SIZE)};

  &:active {
    transform: scale(${SMALL_HOVER_SIZE / SMALL_SIZE});
  }
`;

export const large = css`
  width: ${pxToRem(LARGE_SIZE)};
  height: ${pxToRem(LARGE_SIZE)};

  &:active {
    transform: scale(${LARGE_HOVER_SIZE / LARGE_SIZE});
  }
`;

export const buttonOverrides = css`
  border-radius: 50%;
  border: none !important;
  padding: 0;

  .${BUTTON__CONTENT_CLASS} {
    display: flex;
    justify-content: center;
  }

  &.focus-visible:focus {
    background-color: var(--neutral-white-base);
  }
`;
